import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogCloseComponent } from './dialog-close.component';
import { AngularMaterialModule } from 'src/app/angular-material.module';

@NgModule({
  declarations: [DialogCloseComponent],
  imports: [CommonModule, AngularMaterialModule],
  exports: [DialogCloseComponent],
})
export class DialogCloseModule {}
